/* Shared, side-effect-free cart validation. No customer data is sent elsewhere. */
(function (root) {
  function validate(cart, engravingId) {
    const errors = [];
    const groups = new Map();
    const items = cart.items || [];
    const props = item => item.properties || {};
    for (const item of items) {
      const p = props(item);
      const needs = p['刻印サービス'] === 'あり' || Boolean(p['Gift Box']);
      const code = p['Option Code'];
      if (!code) {
        if (needs || p.Type === 'Option') errors.push('紐づけのないオプションがあります。対象商品を削除し、商品ページから追加し直してください。');
        continue;
      }
      if (!groups.has(code)) groups.set(code, []);
      groups.get(code).push(item);
    }
    for (const lines of groups.values()) {
      const parents = lines.filter(item => props(item).Type !== 'Option');
      const children = lines.filter(item => props(item).Type === 'Option');
      if (parents.length !== 1) {
        errors.push('オプションの対象商品を特定できません。対象商品を削除し、追加し直してください。');
        continue;
      }
      const parent = parents[0], p = props(parent);
      const expected = new Map();
      if (p['刻印サービス'] === 'あり') expected.set(String(engravingId), parent.quantity);
      if (p['Gift Box']) {
        let id = p._gift_variant_id;
        // Existing carts store the gift title, but not its variant ID.
        if (!id) {
          const matching = children.filter(item => (item.product_title || item.title) === p['Gift Box'] && String(item.variant_id || item.id) !== String(engravingId));
          const ids = [...new Set(matching.map(item => String(item.variant_id || item.id)))];
          if (ids.length === 1) id = ids[0];
        }
        if (!id) errors.push('選択したGift Boxが見つかりません。対象商品を追加し直してください。');
        else expected.set(String(id), (expected.get(String(id)) || 0) + parent.quantity);
      }
      const actual = new Map();
      for (const child of children) {
        const id = String(child.variant_id || child.id);
        actual.set(id, (actual.get(id) || 0) + child.quantity);
      }
      if ([...expected].some(([id, quantity]) => actual.get(id) !== quantity) || [...actual.keys()].some(id => !expected.has(id))) {
        errors.push('刻印またはGift Boxの商品・数量が対象商品と一致していません。対象商品を削除し、商品ページから追加し直してください。');
      }
    }
    return [...new Set(errors)];
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = validate;
  else root.galbeValidateOptions = validate;
})(typeof window !== 'undefined' ? window : globalThis);
